import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../utils/Hooks";
import {setSeen} from "../../../store/reducers/InquiriesSlice";

interface InquiriesTableProps {
}

export const InquiriesTable: React.FC<InquiriesTableProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const inquiriesState = useAppSelector(state => state.inquiries);

    const viewHistory = (client: string): string => {
        const link = '/orders?startCountry=0&fromDate=01.01.2015&toDate=&user=-1&destinationCountry=0&status=all&perpage=80&client=' + client + '&service=0&amountFrom=&amountTo=&minus=0&nooffer=0&tab=';
        return link;
    };

    const viewInquiryHistory = (client: string): string => {
        const year = new Date().getFullYear();
        const link = '/inquiries?fromDate=01.01.2015&toDate=31.12.' + year + '&client=' + client + '&status=all';
        return link;
    };

    return (
        <table className="data">
            <thead>
            <tr>
                <th>Kuupäev</th>
                <th>Klient</th>
                <th>Teenuse liik</th>
                <th>Marsruut</th>
                <th>Kommentaar</th>
                <th>Kogus</th>
                <th className="right w150"></th>
            </tr>
            </thead>
            <tbody>
            {inquiriesState.inquiries.map(row => {

                let cellClass = !row.seen_at ? 'blurry-text' : undefined;

                return (
                    <tr key={row.id} onClick={() => {
                        if ( cellClass === 'blurry-text' ) {
                            dispatch(setSeen(row.id));
                        }
                    }}>
                        <td className={cellClass}>{row.created_at}</td>
                        <td>
                            <Link to={`/clients/${row.client_id}/modify`}>{row.client_name}</Link>
                            {row.tax_dept == 1 &&
                            <p style={{color: 'red', fontWeight: 'bold'}}>
                                Maksuvõlg
                            </p>}
                        </td>
                        <td className={cellClass}>{row.service_name}</td>
                        <td className={cellClass}>{row.route}</td>
                        <td className={cellClass}>{row.comment}</td>
                        <td className={cellClass}>{row.amount}</td>
                        <td className={cellClass || 'action'}>
                            {row.archived_at &&
                            <Link to={`/inquiries/${row.id}/archive`}
                                  style={{marginLeft: 3, marginRight: 3}}>Dearhiveeri</Link>
                            }
                            {!row.archived_at &&
                            <Link to={`/inquiries/${row.id}/archive`}
                                  style={{marginLeft: 3, marginRight: 3}}>Arhiveeri</Link>
                            }
                            <span>|</span>
                            {row.state !== 'answered' &&
                            <Link to={`/inquiries/${row.id}/mark-answered`}
                                  style={{marginLeft: 3, marginRight: 3}}>Vastatud</Link>
                            }
                            {row.state === 'answered' &&
                            <Link to={`/inquiries/${row.id}/mark-unanswered`}
                                  style={{marginLeft: 3, marginRight: 3}}>Vastamata</Link>
                            }
                            <span>|</span>
                            <Link to={`/orders/new/${row.id}/inquiry`} style={{marginLeft: 3, marginRight: 3}}>Veoks</Link>
                            <span>|</span>
                            <Link to={`/inquiries/${row.id}/modify`} style={{marginLeft: 3, marginRight: 3}}>Muuda</Link>
                            <span>|</span>
                            <Link to={`/inquiries/${row.id}/recommended`} style={{marginLeft: 3, marginRight: 3, fontSize: 16}}>⛟</Link>
                            <span>|</span>
                            <a href={row.client_name ? viewHistory(row.client_name) : ''} style={{marginLeft: 3, marginRight: 3, fontSize: 14}}>$</a>
                            <span>|</span>
                            <a href={row.client_name ? viewInquiryHistory(row.client_name) : ''} style={{marginLeft: 3, marginRight: 3, fontSize: 14}}>✉️</a>
                            <span>|</span>
                            <Link to={`/inquiries/${row.id}/delete`} style={{marginLeft: 3, marginRight: 3}}>🗑️</Link>
                            <p style={{ whiteSpace: 'initial', fontWeight: 'bold' }}>
                                {row.client_comment}
                            </p>
                        </td>
                    </tr>
                )
            })}
            </tbody>
        </table>
    );

}